import { z } from 'zod';
// Enums matching existing types
export const LicenceTypeSchema = z.enum(['MARKETPLACE', 'PRIVATE']);
export const LicenceStatusSchema = z.enum(['ACTIVE', 'INACTIVE', 'PENDING', 'ACTIVE_NO_HUB_ACCOUNT_ID']);
// Customer Details
export const CustomerDetailsSchema = z.object({
    name: z.string(),
    email: z.string().email(),
    company: z.string(),
});
// Entitlements
export const EntitlementSchema = z.object({
    expiration_date: z.string().optional(),
    account_count: z.number().int().optional(),
});
// Main Licence Record Schema
export const LicenceRecordSchema = z.object({
    customer_key: z.string().optional(),
    api_gw_key_id: z.string().optional(),
    current_account_count: z.number().int().optional(),
    licence_type: LicenceTypeSchema,
    status: LicenceStatusSchema,
    valid_through: z.string().optional(),
    purchaser_aws_account_id: z.string().optional(),
    hub_aws_account_id: z.string().optional(),
    customer_details: CustomerDetailsSchema.optional(),
    registration_email: z.string().email().optional(),
    last_updated: z.string().optional(),
    max_accounts: z.number().int().optional(),
    product_code: z.string().optional(),
    session_token: z.string().optional(),
    session_expiry: z.string().optional(),
    entitlements: z.array(EntitlementSchema).optional(),
    version: z.string().optional(),
    customer_identifier: z.string().optional(),
});
//# sourceMappingURL=licence.schema.js.map